import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Message } from 'semantic-ui-react';

const RecurringPayments = ({ items, onAddClick, onEditClick, onRemoveClick, actions }) => {
	const valid = ['In-Force', 'Future', 'Pending'];
	const [error, setError] = useState(false);

	const load = useCallback(async () => {
		if (items.length > 0) {
			try {
				setError(false);
				await actions.getPaymentWallets(items.map((p) => p.policyNumber));
			} catch {
				setError(true);
			}
		}
	}, [actions, items]);

	useEffect(() => {
		load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<React.Fragment>
			{error && <Message error>Failed to load wallet</Message>}
			{!error && (
				<Table celled unstackable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Options</Table.HeaderCell>
							<Table.HeaderCell>Policy Number</Table.HeaderCell>
							<Table.HeaderCell>Policy Status</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{items
							.filter((item) => item.status !== 'Future')
							.map((item, index) => {
								const isPPA = item.policyNumber.toLowerCase().startsWith('ppa');
								if (isPPA || item.billing.isPartOfAccountBill) {
									return (
										<Table.Row key={index}>
											<Table.Cell>
												{!isPPA && !item.billing.isPartOfAccountBill && item.billing.hasRecurringPaymentSetup && !item.billing.isPolicyInNoticeOfCancellation && valid.some((v) => v === item.status) && <Button content='Edit' onClick={onEditClick} data={item} />}
												{`${item.billing.isPartOfAccountBill ? `This policy is part of ${item.billing.accountNumber}. ` : ``}Please contact your agent at ${item.agency.phones[0]} to make changes.`}
											</Table.Cell>
											<Table.Cell>{item.policyNumber}</Table.Cell>
											<Table.Cell>{item.status === 'History' ? 'Cancelled' : item.status}</Table.Cell>
										</Table.Row>
									);
								}

								return (
									<Table.Row key={index}>
										{!item.billing.hasRecurringPaymentSetup ? (
											<Table.Cell>
												<Button disabled={!valid.some((v) => v === item.status) || item.billing.isPolicyInNoticeOfCancellation} content='Add' onClick={onAddClick} data={item} />
											</Table.Cell>
										) : (
											<Table.Cell>
												<Button disabled={!valid.some((v) => v === item.status) || item.billing.isPolicyInNoticeOfCancellation} content='Edit' onClick={onEditClick} data={item} />
												<Button disabled={!valid.some((v) => v === item.status) || item.billing.isPolicyInNoticeOfCancellation} content='Cancel' onClick={onRemoveClick} data={item} />
											</Table.Cell>
										)}
										<Table.Cell>{item.policyNumber}</Table.Cell>
										<Table.Cell>{item.status === 'History' ? 'Cancelled' : item.status}</Table.Cell>
									</Table.Row>
								);
							})}
					</Table.Body>
				</Table>
			)}
		</React.Fragment>
	);
};

RecurringPayments.propTypes = {
	items: PropTypes.array.isRequired,
	onAddClick: PropTypes.func.isRequired,
	onEditClick: PropTypes.func.isRequired,
	onRemoveClick: PropTypes.func.isRequired,
};

export default RecurringPayments;
